import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

function LocationMap() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Location Tracking</Typography>
      <Paper sx={{ p: 3, height: 600 }}>
        <Typography color="textSecondary">
          Map view with real-time device locations will appear here.
          Install react-leaflet for full implementation.
        </Typography>
      </Paper>
    </Box>
  );
}

export default LocationMap;
